import { render, staticRenderFns } from "./CameraPageShootMessageOpdoc.vue?vue&type=template&id=0bc265bb&scoped=true&"
import script from "./CameraPageShootMessageOpdoc.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootMessageOpdoc.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootMessageOpdoc.vue?vue&type=style&index=0&id=0bc265bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc265bb",
  null
  
)

export default component.exports